import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const vehicleOutboundBusinessTypeEnum = createEnum({
    SELF_OPERATED: ['self_operated', '自营业务', 'blue'],
    FINANCED: ['financed', '垫资业务', 'purple'],
    JOINT_PURCHASE: ['joint_purchase', '联合采购', 'cyan'],
    CLIENT_ENTRUSTED: ['client_entrusted', '客户委托', 'gold'],
});
export const VEHICLE_OUTBOUND_BUSINESS_TYPES = enumValues(vehicleOutboundBusinessTypeEnum);
export const VEHICLE_OUTBOUND_BUSINESS_TYPE_LABEL_MAP = enumLabelMap(vehicleOutboundBusinessTypeEnum);
export const vehicleOutboundTypeEnum = createEnum({
    SALE: ['sale', '销售出库', 'blue'],
    TRANSFER: ['transfer', '调拨出库', 'orange'],
});
export const VEHICLE_OUTBOUND_TYPES = enumValues(vehicleOutboundTypeEnum);
export const VEHICLE_OUTBOUND_TYPE_LABEL_MAP = enumLabelMap(vehicleOutboundTypeEnum);
export const vehicleOutboundStatusEnum = createEnum({
    REVIEWING: ['reviewing', '审核中', 'blue'],
    PENDING_OUTBOUND: ['pending_outbound', '待出库', 'orange'],
    OUTBOUND: ['outbound', '已出库', 'green'],
    REJECTED: ['rejected', '已拒绝', 'red'],
});
export const VEHICLE_OUTBOUND_STATUSES = enumValues(vehicleOutboundStatusEnum);
export const VEHICLE_OUTBOUND_STATUS_LABEL_MAP = enumLabelMap(vehicleOutboundStatusEnum);
//# sourceMappingURL=vehicle-outbound.js.map